module.exports = __webpack_public_path__ + "img/Profil_CS-Hybrid_Standard.efd066d3.jpg";